<template>
  <div class="selectTeacher">
    <el-page-header @back="goback" content="爽约/取消" > </el-page-header>
    <el-card class="box-card">
      <AppointInfo :appoint="appoint"></AppointInfo>
    </el-card>
    <p class="text-center" style="color:rgb(48, 49, 51);font-size:12px; margin-bottom:12px;">原因：{{appoint.memo}}</p>
    <p class="text-center mt10" :class="getStatusClass(appoint.label)">{{parseAppointStatus(appoint.status)}}</p>
  </div>
</template>

<script>
import { mapState } from "vuex";
import HttpRequest from "@/utils/request";
import { parseAppointStatus,getStatusClass } from "@/utils/status.js";
import AppointInfo from '@/components/appointInfo'
export default {
  components: {
    AppointInfo,
  },
  data() {
    return {
      appoint: {},
      scheduleId: null,
      pathfrom: null,
      //
      parseAppointStatus,
      getStatusClass,
    };
  },
  computed: {
    ...mapState({
      student: (state) => state.user.student,
    }),
  },
  created() {
    if (this.$route.query.scheduleId) {
      this.scheduleId = this.$route.query.scheduleId;
      this.getSchedule();
    }
    else{
      this.$alert('请求url缺乏必须的参数',  {confirmButtonText: '确定',showClose: false,});
    }
    this.pathfrom = this.$route.query.pathfrom;
  },
  mounted() {
    document.title = '预约爽约/取消'
  },
  methods: {
    parseStatus(status) {
      return status == 31 ? '来访者取消' : status == 36 ? '咨询师取消' : status == 51 ? '来访者爽约' : status == 56 ? '咨询师爽约' : '';
    },
    goback() {
      // this.$router.back();
      this.$router.push("appointView");
    },
    getSchedule(){
      let url = "/constub/getSchedule";
      let data = { token: this.student.token, scheduleId: this.scheduleId };
      HttpRequest.requestFormPost(url, data).then(res => {
        if (res && res.result.success) {
          this.appoint = res.data;
          if(this.appoint.status != 31 && this.appoint.status != 36 && this.appoint.status != 51 && this.appoint.status != 56 ){  //判断状态是否正确
            this.$message({message: '预约状态已变更，跳转回原路径',type: "error",});
            this.$router.push(this.pathfrom?this.pathfrom:'home');
          }
        } else {
          this.$alert(res.result.message,  {
            confirmButtonText: '确定',
            showClose: false,
          });
        }
      });
    },
  }
};
</script>


<style scoped>
>>> .el-dialog {
  position: absolute;
  bottom: 0;
  margin: 0;
}

.title {
  width: 100%;
  padding: 10px;
  background-color: rgb(198, 212, 248);
  text-align: center;
  font-weight: bold;
  margin: 10px 0;
}
.c-talbe {
  display: table-cell;
  width: 100%;
}

.c-talbe td {
  padding: 5px;
}
p {
  line-height: 24px;
}
.borderrd {
  border-radius: 10px;
  border: 1px solid #ccc;
  padding: 10px;
  margin-bottom: 10px;
}
</style>
